import * as XLSX from "xlsx";
import { IAffectedReservation } from "../services/getScheduleImpact.service";

/**
 * US2 spec 016 — Exporta a .xlsx la lista de reservas afectadas por un cambio
 * de horario. Usa la MISMA data del preview para garantizar paridad.
 */
export const exportAffectedReservations = (
  affected: IAffectedReservation[],
  employeeName?: string
): void => {
  const showEmployee = affected.some((r) => !!r.employeeName);
  const rows = affected.map((r) => ({
    "ID Reserva": r.reservationId,
    ...(showEmployee ? { Estilista: r.employeeName || "" } : {}),
    Cliente: r.clientName,
    Servicio: (r.services || []).join(", "),
    "Fecha/Hora": r.dateTime,
    Sede: r.localName ?? "",
    Estado: r.status,
  }));

  const ws = XLSX.utils.json_to_sheet(rows, {
    header: [
      "ID Reserva",
      ...(showEmployee ? ["Estilista"] : []),
      "Cliente",
      "Servicio",
      "Fecha/Hora",
      "Sede",
      "Estado",
    ],
  });
  ws["!cols"] = [
    { wch: 12 },
    ...(showEmployee ? [{ wch: 28 }] : []),
    { wch: 28 },
    { wch: 40 },
    { wch: 20 },
    { wch: 24 },
    { wch: 16 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Reservas afectadas");

  const fecha = new Date().toISOString().slice(0, 10);
  const safeName = employeeName
    ? employeeName.trim().replace(/[^\w\-]+/g, "-").toLowerCase()
    : "";
  const fileName = safeName
    ? `reservas-afectadas-${safeName}-${fecha}.xlsx`
    : `reservas-afectadas-${fecha}.xlsx`;

  XLSX.writeFile(wb, fileName);
};
